export default "__VITE_ASSET__H_z7FAlY__"